import { gql } from "@apollo/client";

/**
 * Domain types for the CNC "Launch Task" GraphQL API.
 *
 * Hand-written to match the query/mutation in this file (no codegen).
 * Exported so the LaunchTask component (converted in a later wave) can import
 * these shapes instead of redefining them.
 */

// --- cnc_tasks ---

export interface CncTaskParameter {
  type: string;
  name: string;
  required: boolean;
  description: string;
}

export interface CncTask {
  task_name: string;
  task_description: string;
  task_parameters: CncTaskParameter[];
}

export interface CncTasksData {
  cnc_tasks: CncTask[];
}

// --- run_cnc_task ---

export interface CncTaskLauncherVariables {
  account_uuid?: string;
  task_name: string;
  // JSONString scalar: a JSON-serialized string of task parameters.
  task_parameters: string;
}

export interface CncTaskLauncherData {
  run_cnc_task: {
    op_id: string;
  };
}

export const CNC_TASKS = gql`
  query cncTasks {
    cnc_tasks {
      task_name
      task_description
      task_parameters {
        type
        name
        required
        description
      }
    }
  }
`;

export const CNC_TASK_LAUNCHER = gql`
  mutation cncTaskLauncher(
    $account_uuid: String
    $task_name: String!
    $task_parameters: JSONString!
  ) {
    run_cnc_task(
      account_uuid: $account_uuid
      task_name: $task_name
      task_parameters: $task_parameters
    ) {
      op_id
    }
  }
`;
